<script lang="ts">
    import { Col } from "sveltestrap";
    import Card from "../../Core/Card.svelte";
    import Link from "svelte-link/src/Link.svelte";
    import { chart } from "svelte-apexcharts";
    import { Transaction } from "../../../Data/Chart/Dashboard/Default/Chart";
    import { href,SuceessfullTransaction, TotalBalance, Transactions, } from "../../../utils/Constant/Constant";
</script>

<Col xl="12" class="box-col-6 des-xl-50">
    <Card cardProps="trasaction-sec" cardBodyprops="p-0">
        <div class="header-top d-sm-flex align-items-center" slot="customheader" >
            <h5>{Transactions}</h5>
            <div class="center-content">
                <p>5878 {SuceessfullTransaction}</p>
            </div>
        </div>  
        <div class="transaction-totalbal" slot="customheader2">
            <h2>
                $2,09,352k
                <span class="ms-3">
                    <Link class="btn-arrow arrow-secondary" {href}>
                        <i
                            class="toprightarrow-secondary fa fa-arrow-up me-2"
                        />98.54%
                    </Link>
                </span>
            </h2>
            <p>{TotalBalance}</p>
        </div>
        <div slot="contentbody">
            <div id="chart-3dash">
                <div use:chart={Transaction} />
            </div>
        </div>
    </Card>
</Col>